import { api } from './api';

export interface OperatorOverrideCreateInput {
  org_id?: string;
  scope: {
    policy_id?: string;
    camera_id?: string;
  };
  overrides: {
    enabled?: boolean;
    severity?: 'low' | 'medium' | 'high' | 'critical';
    cooldown_seconds?: number;
  };
  duration_seconds?: number;
  ends_at?: string;
  reason?: string;
  created_by?: string;
}

export const operatorOverridesApi = {
  async list(siteId: string): Promise<any[]> {
    const resp = await api.get(`/api/v1/sites/${encodeURIComponent(siteId)}/operator_overrides`);
    return resp.data?.items || [];
  },

  async create(siteId: string, input: OperatorOverrideCreateInput): Promise<any> {
    const resp = await api.post(`/api/v1/sites/${encodeURIComponent(siteId)}/operator_overrides`, input);
    return resp.data;
  },

  async revoke(siteId: string, overrideId: string, body?: { reason?: string; revoked_by?: string }): Promise<any> {
    const resp = await api.post(
      `/api/v1/sites/${encodeURIComponent(siteId)}/operator_overrides/${encodeURIComponent(overrideId)}/revoke`,
      body || {},
    );
    return resp.data;
  },
};

